import { mapListToRecords, normalizeList, websocketsHandlerFactory } from '@sophocles/entities/entityUtils';
import {
  SiteConfiguration,
  siteConfigurationSchema,
} from '@sophocles/entities/SiteConfiguration/siteConfigurationRecord';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';
import { normalize } from 'normalizr';

/* Receive Actions */
export const RECEIVE_SITE_CONFIGURATIONS = 'RECEIVE_SITE_CONFIGURATIONS';
export function receiveSiteConfigurations(json) {
  return {
    type: RECEIVE_SITE_CONFIGURATIONS,
    siteConfigurations: mapListToRecords(json, SiteConfiguration),
  };
}

/* Request Actions */
// starter request
export const REQUEST_SITE_CONFIGURATION = 'REQUEST_SITE_CONFIGURATION';
function requestSiteConfigurations(siteConfiguration_id) {
  return {
    type: REQUEST_SITE_CONFIGURATION,
    siteConfiguration_id,
  };
}

export const REQUEST_SITE_SITE_CONFIGURATION = 'REQUEST_SITE_SITE_CONFIGURATION';
function requestSiteConfigurationsBySite(site_id) {
  return {
    type: REQUEST_SITE_SITE_CONFIGURATION,
    site_id,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchSiteConfiguration(siteConfiguration_id) {
  return dispatch => {
    dispatch(requestSiteConfigurations(siteConfiguration_id));
    return apiClient
      .get(`/siteconfiguration/${siteConfiguration_id}/`)
      .then(response => normalizeList(response.data, 'siteConfigurations', siteConfigurationSchema))
      .then(json => dispatch(receiveSiteConfigurations(json.entities.siteConfigurations)))
      .catch(error => {
        dispatch(genericErrorAction(error, REQUEST_SITE_CONFIGURATION));
      });
  };
}

/* Edit Actions */
export const EDIT_SITE_CONFIGURATION = 'EDIT_SITE_CONFIGURATION';
export function editSiteConfiguration(siteConfiguration_id) {
  return {
    type: EDIT_SITE_CONFIGURATION,
    siteConfiguration: siteConfiguration_id,
  };
}

export function patchSiteConfiguration(siteConfiguration_id, values) {
  return dispatch => {
    dispatch(editSiteConfiguration(siteConfiguration_id));
    return apiClient
      .patch(`/siteconfiguration/${siteConfiguration_id}/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, siteConfigurationSchema))
      .then(json => {
        dispatch(receiveSiteConfigurations(json.entities.siteConfigurations));
      })
      .catch(error => {
        dispatch(genericErrorAction(error, EDIT_SITE_CONFIGURATION));
      });
  };
}

/* Create Actions */
export const CREATE_SITE_CONFIGURATION = 'CREATE_SITE_CONFIGURATION';
function sayCreateSiteConfiguration(values) {
  return {
    type: CREATE_SITE_CONFIGURATION,
    values: values,
  };
}

export function createSiteConfiguration(values) {
  return dispatch => {
    dispatch(sayCreateSiteConfiguration(values));
    return apiClient
      .post(`/siteconfiguration/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, siteConfigurationSchema))
      .then(json => {
        dispatch(receiveSiteConfigurations(json.entities.siteConfigurations));
      })
      .catch(error => {
        dispatch(genericErrorAction(error, CREATE_SITE_CONFIGURATION));
      });
  };
}

/* Delete Actions */
export const DELETE_SITE_CONFIGURATION = 'DELETE_SITE_CONFIGURATION';
function sayDeleteSiteConfiguration(siteConfiguration_id) {
  return {
    type: DELETE_SITE_CONFIGURATION,
    siteConfiguration: siteConfiguration_id,
  };
}

export function deleteSiteConfiguration(siteConfiguration_id) {
  return dispatch =>
    apiClient
      .delete(`/siteconfiguration/${siteConfiguration_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteSiteConfiguration(siteConfiguration_id)))
      .catch(error => {
        dispatch(genericErrorAction(error, DELETE_SITE_CONFIGURATION));
      });
}

const receiver = (dispatch, json) => dispatch(receiveSiteConfigurations(json.entities.siteConfigurations));

export const handleSiteConfigurationSocketActions = websocketsHandlerFactory(
  receiver,
  sayDeleteSiteConfiguration,
  siteConfigurationSchema,
);
